import React, {useState} from 'react';

const useMinimizar = () => {
    //Crear estado que sea activoToEdit.
    const [activoToEdit,setActivoToEdit] = useState({});
    const [indexToEdit,setIndexToEdit] = useState(-1);
    const [indexAddConsumo,setIndexAddConsumo] = useState(-1);
    const [formToShow,setFormToShow] = useState('');

    const minimizar = () => {
        setActivoToEdit({});
        setIndexToEdit(-1);
        setFormToShow('');
    }
    
    const minimizarFormConsumo = () => {
        setActivoToEdit({});
        setIndexAddConsumo(-1);
    }

    return {activoToEdit,setActivoToEdit,indexToEdit,setIndexToEdit,indexAddConsumo,setIndexAddConsumo,formToShow,setFormToShow,minimizar,minimizarFormConsumo}
}

export default useMinimizar;